import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

/**时段信息 */
export const Availabilities = ({ availabilities, onClick }) => {
  const { t } = useTranslation();
  const times = useMemo(() => {
    try {
      return availabilities.time_slots || [];
    } catch (error) {
      return [];
    }
  }, [availabilities]);
  const date = useMemo(() => {
    try {
      return {
        ...times[0],
        formated_time: "",
      };
    } catch (error) {
      return null;
    }
  }, [times]);
  const title = useMemo(() => {
    // 当含有折扣时段，显示折扣标题
    const hasDiscount = times.some((item) => !!item.formated_discount);
    return hasDiscount ? t("WEB.Restaurant_Book_now") : t("WEB.A la carte");
  }, [times, t]);
  if (!availabilities) return null;
  return (
    <section className="page-restaurant--availabilities hairline-bottom">
      <div className="title flex">
        <h3>{title}</h3>
        <span className="inline-flex" onClick={() => onClick(date)}>
          <i className="icon icon-date"></i>
          {availabilities.date}
        </span>
      </div>

      <div className="availabilities-list">
        {times.map((item, index) => {
          return (
            <div
              className="list-item"
              key={index}
              onClick={() => onClick(item)}
              data-discount={item.formated_discount}
            >
              <p>{item.formated_time}</p>
              {item.formated_discount ? (
                <span>{item.formated_discount}</span>
              ) : (
                <span>
                  {item.seats} {t("SEATS")}
                </span>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
};
